import React, { useEffect, useRef, useState } from 'react';
import { stats } from '../data/mock';
import { Card } from './ui/card';

const Stats = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          }
        });
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="py-20 px-6">
      <div className="container mx-auto max-w-6xl">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {stats.map((stat, index) => (
            <Card
              key={index}
              className={`p-6 border-2 hover:border-cyan-500/50 transition-all duration-300 ${
                isVisible ? 'animate-in' : 'opacity-0'
              }`}
              style={{
                animationDelay: `${index * 0.1}s`
              }}
            >
              <div className="space-y-2">
                <div className="text-4xl font-bold font-mono text-cyan-500">
                  {stat.number}
                </div>
                <p className="text-sm text-muted-foreground leading-relaxed">
                  {stat.label}
                </p>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;
